import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import supabase from '../utils/Supabase';
import { getUserInfo, insertNewUser } from '../utils/UserUtil';

import useUserStore from "../stores/User";

function CheckRights() {
    const userData = useUserStore((state) => state.data);
    const setUserData = useUserStore((state) => state.setUserData);
    const [rightsError, setRightsError] = useState("");

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get("redirectTo") || "/database";

    useEffect(() => {
        // If userData is already loaded, redirect
        if (userData) {
            navigate(redirectTo);
            return;
        }

        // Otherwise, fetch user info
        const fetchUser = async () => {
            const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
            
            if (sessionError || !sessionData?.session?.user) {
                // No valid session, redirect to login so the user can try again
                navigate("/DatabaseLogin");
                return;
            }
            
            const user = sessionData.session.user;
            const data = await getUserInfo(user.id);
            
            if (data == null) {
                // Onboard new user
                const newUser = await insertNewUser(user.id, user.email);
                if (newUser) {
                    setUserData({ ...newUser });
                    navigate(redirectTo);
                } else {
                    setRightsError("Sorry, I was unable to log you in. Please contact support.");
                }
            } else {
                setUserData({ ...data });
                navigate(redirectTo);
            }
        };

        fetchUser();
    }, [userData, setUserData, navigate, redirectTo]);

    return (rightsError ?
        <main className="d-flex" style={{ flex: "max-content" }}>
            <div className="mx-3 my-auto mx-sm-auto">
                <p className="text-center my-3">{rightsError}</p>
            </div>
        </main>
        :
        null
    );
}

export default CheckRights